module.exports = __webpack_public_path__ + "skins/lightgray/fonts/tinymce-small.woff";